import { render, staticRenderFns } from "./addUploadImgPage.vue?vue&type=template&id=55c63d86&"
import script from "./addUploadImgPage.vue?vue&type=script&lang=js&"
export * from "./addUploadImgPage.vue?vue&type=script&lang=js&"
import style0 from "./addUploadImgPage.vue?vue&type=style&index=0&id=55c63d86&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports